// extracted by mini-css-extract-plugin
export var menuIcon = "_rg-0";
export var menuIconInline = "_rg-1";